import { render, staticRenderFns } from "./AgendaCreateEditSession.vue?vue&type=template&id=31542768&scoped=true&"
import script from "./AgendaCreateEditSession.vue?vue&type=script&lang=js&"
export * from "./AgendaCreateEditSession.vue?vue&type=script&lang=js&"
import style0 from "./AgendaCreateEditSession.vue?vue&type=style&index=0&id=31542768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31542768",
  null
  
)

export default component.exports